import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { product } from '../Product';
import { productGroupByCategory } from '../ProductGroupByCategory';

const body = z
    .object({
        productIds: z.array(z.string())
    })
    .strict();

const productPacksResult = z
    .object({
        packWithProducts: z.array(product),
        productGroupsByCategory: z.array(productGroupByCategory)
    })
    .strict();

export const productPacks = {
    verb: 'post',
    path: 'product-packs',
    schema: {
        body,
        response: {
            200: productPacksResult
        }
    }
} as const satisfies EndpointContract;

export type ProductPacksResult = z.infer<typeof productPacksResult>;
